import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import * as firebase from "firebase/app";
import "firebase/analytics";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCW5dzj1evseji694CRpB85ExLUkhRjNNg",
  authDomain: "joinp-ee683.firebaseapp.com",
  databaseURL: "https://joinp-ee683.firebaseio.com",
  projectId: "joinp-ee683",
  storageBucket: "joinp-ee683.appspot.com",
  messagingSenderId: "998594366611",
  appId: "1:998594366611:web:c38b8a2de5e3eafeb4d166",
  measurementId: "G-R4BNTYDR7W"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const a = firebase.analytics();

Vue.prototype.$analytics = a;

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
